import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

ReportsCreateShowMultiselectModalController.$inject = ['$scope', '$uibModalInstance', 'filter', 'currentValues'];

function ReportsCreateShowMultiselectModalController(
  $scope: IScope & {
    init: TODO;
    filter: TODO;
    model: TODO;
    cache: TODO;
    selected: TODO;
    toggleSelected: TODO;
    toggleColumn: TODO;
    selectedCount: number;
    countSelected: TODO;
    hasSelected: TODO;
    hasErrors: TODO;
    done: TODO;
    errors: TODO[];
    success: TODO;
    cancel: TODO;
  },
  $uibModalInstance: UIBModal<string>,
  filter: { fieldName: string; fieldValue: TODO },
  currentValues: TODO
) {
  $scope.errors = [];

  $scope.model = [];
  $scope.filter = [];
  $scope.selected = {};
  $scope.selectedCount = 0;

  $scope.init = function () {
    $scope.filter = angular.copy(filter);
    $scope.model = angular.copy(currentValues);
    $scope.cache = angular.copy(currentValues);
    $scope.selected = {};
    $scope.toggleSelected();
  };

  $scope.toggleColumn = function (value) {
    $scope.selected[value] = !$scope.selected[value];

    if ($scope.selected[value]) {
      $scope.selectedCount++;
    } else {
      $scope.selectedCount--;
    }
  };

  $scope.toggleSelected = function () {
    const values = $scope.filter.fieldValue ? $scope.filter.fieldValue.split(',') : [];

    $scope.selectedCount = 0;

    for (let i = 0, ii = values.length; i < ii; i++) {
      $scope.selected[values[i]] = true;
      $scope.selectedCount++;
    }
  };

  $scope.countSelected = function () {
    $scope.selectedCount = 0;

    for (const field in $scope.selected) {
      if ($scope.selected.hasOwnProperty(field) && $scope.selected[field]) {
        $scope.selectedCount++;
      }
    }

    return $scope.selectedCount;
  };

  $scope.hasSelected = function () {
    return $scope.selectedCount > 0;
  };

  $scope.hasErrors = function () {
    return $scope.errors.length > 0;
  };

  $scope.done = function () {
    $scope.errors = [];

    if ($scope.hasSelected()) {
      $scope.success();
    } else {
      $scope.errors.push({
        message: 'You must select at least one field',
      });
    }
  };

  $scope.cancel = function () {
    $scope.errors = [];
    // Restore cached
    $scope.model = angular.copy($scope.cache);
    $scope.toggleSelected();

    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    const results: TODO[] = [];

    for (const field in $scope.selected) {
      if ($scope.selected.hasOwnProperty(field) && $scope.selected[field]) {
        results.push(field);
      }
    }

    $uibModalInstance.close(results.join(','));
  };

  $scope.init();
}

export const ReportsCreateShowMultiselectModalControllerModule = angular
  .module('acme.view.application.reports.create.showMultiselectModal.controllers', [])
  .controller('ReportsCreateShowMultiselectModalController', ReportsCreateShowMultiselectModalController).name;
